import type { ServiceLinkEntry } from "@/lib/serviceLinkTypes";

/**
 * Batch 29 — HubSpot Reporting / Custom Property / Pipeline Velocity /
 * Forecasting Dashboard cluster (4 of 12 posts) → /hubspot-revops-architect.
 *
 * The other 8 Batch 29 posts are legal/compliance/tax/offboarding and
 * time-zone/management topics → homepage contextual link via HIRING_TOPIC_SLUGS.
 *
 * See INTERNAL_LINKING_GUIDE.md + CONTENT_OPTIMIZATION_GUIDE.md.
 */
export const BATCH29_SERVICE_LINKS: Record<string, ServiceLinkEntry> = {
  "cross-object-reporting-specialist-hubspot": {
    url: "/hubspot-revops-architect",
    anchor: /cross object reporting specialist for HubSpot/i,
    label: "hire a HubSpot RevOps architect",
  },
  "hubspot-custom-property-sync-for-tracking": {
    url: "/hubspot-revops-architect",
    anchor: /HubSpot custom property sync for tracking/i,
    label: "hire a HubSpot RevOps architect",
  },
  "optimize-hubspot-deal-pipeline-stage-velocity": {
    url: "/hubspot-revops-architect",
    anchor: /optimize HubSpot deal pipeline stage velocity/i,
    label: "hire a HubSpot RevOps architect",
  },
  "hubspot-forecasting-dashboard-setup-freelancer": {
    url: "/hubspot-revops-architect",
    anchor: /HubSpot forecasting dashboard setup freelancer/i,
    label: "hire a HubSpot RevOps architect",
  },
};
